import styled from '@benzinga/themetron';
import { SearchTool } from './SearchBarTool';
import React from 'react';
import { SearchBarProps } from '../SearchBar';
import { ChevronUp } from '@benzinga/themed-icons';

export const DROPDOWN_TOOL_ID = 'dropdown' as const;

export interface DropdownTool extends SearchTool {
  id: typeof DROPDOWN_TOOL_ID;
}

export const createDropdownTool = (): DropdownTool => {
  return {
    getTool: (_: SearchBarProps, searchBarState, setSearchBarState) => {
      return (
        searchBarState.isOpen && (
          <CloseDropdownIcon
            key={DROPDOWN_TOOL_ID}
            onClick={e => {
              e.preventDefault();
              e.stopPropagation();
              setSearchBarState(s => ({ ...s, isOpen: false }));
            }}
          />
        )
      );
    },
    id: DROPDOWN_TOOL_ID,
  };
};

export function isDropdownTool(tool: SearchTool): tool is DropdownTool {
  return tool.id === DROPDOWN_TOOL_ID;
}

export const useDropdownTool = (): DropdownTool => {
  return React.useMemo(() => createDropdownTool(), []);
};

const CloseDropdownIcon = styled(ChevronUp)`
  fill: ${props => props.theme.colors.foregroundInactive};
  font-size: 24px;
  cursor: pointer;
  margin: 2px;
`;
